export default {"src":"/_next/static/media/404_l.08b998bf.svg","height":204,"width":570,"blurWidth":0,"blurHeight":0};